const routes = window.app.routes;

window.addEventListener('DOMContentLoaded', () => {
    for (let phoneNode of document.querySelectorAll('.user-template-phone .phone-number')) {
        phoneNode.addEventListener('click', e => {
            if ('phoneNo' in phoneNode.dataset) {
                const number = phoneNode.dataset.phoneNo;
                phoneNode.innerHTML = number;
                phoneNode.href = 'tel:' + number;
                delete phoneNode.dataset.phoneNo;

                if ('providerId' in phoneNode.dataset && phoneNode.dataset.providerId) {
                    fetch(routes['BASE_REST_URL'] + routes['NAME_SPACE'] + '/' + routes['LOG_PHONE_CLICK'], {
                        headers: {'Content-Type': 'application/json'},
                        method: 'POST',
                        body: JSON.stringify({
                            'id': parseInt(phoneNode.dataset.providerId),
                        }),
                    });
                }
            }
        });
    }
});